import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-calendar',
  templateUrl: './manage-calendar.component.html',
  styleUrls: ['./manage-calendar.component.css']
})
export class ManageCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
